// src/pages/pedidos/TaxaEntregaBairroCad.js
import React, { useEffect, useState } from 'react';

import Input from '../../components/input/Input';
// import Select from '../../components/input/Select';
import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalHeader from '../../components/modalForm/ModalHeader';
import ModalBody from '../../components/modalForm/ModalBody';
import ModalFooter from '../../components/modalForm/ModalFooter';
import { TaxaEntregaBairro } from '../../models/pedidos/TaxaEntregaBairro';
import { useTaxaEntregaBairro } from '../../contexts/pedidos/TaxaEntregaBairroContext';
// import { useCidades } from '../../contexts/geral/CidadeContext';
import { useMessage } from '../../contexts/geral/MessageContext';
import { useYesNo } from '../../contexts/geral/YesNoContext';
import TaxaEntregaBairroSearch from './TaxaEntregaBairroSearch';
import { formatNumeric, normalizeDecimalInputBr, parseNumeric } from '../../utils/numberUtils';
import ModalActions, { ModalActionButton } from '../../components/modalForm/ModalActions';

const TaxaEntregaBairroCad = ({ show, onHide }) => {
  const { addTaxaEntregaBairro, updateTaxaEntregaBairro, deleteTaxaEntregaBairro } = useTaxaEntregaBairro();
  // const { cidades } = useCidades();
  const { showMessage } = useMessage();
  const { showYesNo } = useYesNo();
  const [taxa, setTaxa] = useState(new TaxaEntregaBairro(0, 1));
  const [novo, setNovo] = useState(true);
  const [showSearch, setShowSearch] = useState(false);

  const handleNovo = () => { setTaxa({ ...new TaxaEntregaBairro(0, 1), valor: formatNumeric(0) }); setNovo(true); };
  useEffect(() => { if (show) { handleNovo(); setShowSearch(false); } }, [show]);

  const handleSave = async () => {
    // if (!taxa.cidadeId) return showMessage('Informe o município.');
    if (!taxa.descricao?.trim()) return showMessage('Informe a descrição do bairro.');
    if (taxa.valor === '' || !Number.isFinite(parseNumeric(taxa.valor)) || parseNumeric(taxa.valor) < 0) return showMessage('Informe um valor válido.');
    try {
      if (taxa.id) await updateTaxaEntregaBairro(taxa); else await addTaxaEntregaBairro(taxa);
      handleNovo();
    } catch (_) { }
  };

  const handleDelete = async () => {
    if (!taxa.id) return showMessage('Selecione uma taxa de entrega por bairro para excluir.');
    if (await showYesNo('Deseja excluir a taxa de entrega por bairro selecionada?')) {
      try { await deleteTaxaEntregaBairro(taxa.id); handleNovo(); } catch (_) { }
    }
  };

  if (!show) return null;
  return (
    <ModalContainer show={show} variant="cadastro" onHide={onHide}>
      <ModalHeader title={novo ? 'Nova Taxa de Entrega por Bairro' : 'Alterar Taxa de Entrega por Bairro'} onHide={onHide} />
      <ModalBody><div className="input-group mb-3">
        <Input label="Código" value={taxa.id || ''} onChange={() => {}} disabled={!novo} btnBuscar={() => setShowSearch(true)} />
        {/* <Select label="Município" value={taxa.cidadeId || ''} onChange={(e) => setTaxa({ ...taxa, cidadeId: Number(e.target.value) })}
          options={[{ value: '', label: 'Selecione...' }, ...cidades.map((c) => ({ value: c.id, label: `${c.nome}${c.uf ? `/${c.uf}` : ''}` }))]} size="240px" /> */}
        <Input label="Bairro" value={taxa.descricao || ''} onChange={(e) => setTaxa({ ...taxa, descricao: e.target.value })} size="240px" />
        <Input label="Valor" type="text" value={taxa.valor ?? ''}
          onChange={(e) => setTaxa({ ...taxa, valor: normalizeDecimalInputBr(e.target.value) })}
          onBlur={(e) => setTaxa({ ...taxa, valor: formatNumeric(e.target.value) })} style={{ textAlign: 'right' }} />
      </div></ModalBody>
      <ModalFooter><ModalActions >
        <ModalActionButton className="btn btn-primary" onClick={handleSave} action="save">Salvar </ModalActionButton>
        <ModalActionButton className="btn btn-danger" onClick={handleDelete} disabled={novo} action="delete">Excluir </ModalActionButton>
        <ModalActionButton className="btn btn-secondary" onClick={handleNovo} disabled={novo} action="new">Novo </ModalActionButton>
      </ModalActions></ModalFooter>
      <TaxaEntregaBairroSearch show={showSearch} onHide={() => setShowSearch(false)} onSelect={(item) => { setTaxa({ ...item, cidadeId: 1, valor: formatNumeric(item.valor) }); setNovo(false); setShowSearch(false); }} />
    </ModalContainer>
  );
};

export default TaxaEntregaBairroCad;
